/**
 * Track high-intent contact actions: phone calls, email clicks.
 * Fires GA4 `contact` event when a `tel:` or `mailto:` link is clicked.
 */

export function init() {
  document.addEventListener("click", handleClick, { capture: true });
}

function handleClick(e) {
  const link = e.target.closest("a[href^='tel:'], a[href^='mailto:']");
  if (!link || typeof window.gtag !== "function") {
    return;
  }

  const href = link.getAttribute("href") || "";
  const method = href.startsWith("tel:") ? "phone" : "email";
  const value = href.replace(/^(tel:|mailto:)/, "");

  window.gtag("event", "contact", {
    method,
    contact_value: value,
    location: location.pathname,
  });
}
